var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBeeStrongActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 107.928,
    height: 73.093,
    viewBox: "0 0 107.928 73.093",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_103",
    "data-name": "Rectangle 103",
    width: 107.928,
    height: 73.093,
    transform: "translate(0 0)",
    fill: "#ed3a72"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_188",
    "data-name": "Group 188",
    transform: "translate(0 -0.005)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_187",
    "data-name": "Group 187",
    transform: "translate(0 0.005)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3951",
    "data-name": "Path 3951",
    d: "M65.286,215.211a8.543,8.543,0,0,1-.122,3.652,10.448,10.448,0,0,1-8.3,7.723c-4.818,1.117-9.053-.072-12.328-3.955a8.662,8.662,0,0,1-2.061-6.47c.021-.271,0-.544,0-.922-1.219.459-2.394.914-3.578,1.346a88.6,88.6,0,0,1-12.125,3.967,30.6,30.6,0,0,1-11.7.443,6.658,6.658,0,0,1-3.294-1.471,4.32,4.32,0,0,1-1.549-4.3c.12-.618-.017-.837-.617-1.045a15.273,15.273,0,0,1-8.059-5.946,9.43,9.43,0,0,1-1.507-4.088,5.966,5.966,0,0,1,3.6-6.382,14.976,14.976,0,0,1,5.728-1.2A46.2,46.2,0,0,1,26.2,199.5c5.567,1.925,11,4.184,16.436,6.456.628.263.95.252,1.384-.378,2.77-4.021,6.828-5.164,11.414-4.743a10.84,10.84,0,0,1,8.757,5.122c.28.455.57.185.848.073,2.8-1.121,5.58-2.274,8.384-3.375a104.234,104.234,0,0,1,14.664-4.991,35.393,35.393,0,0,1,12.51-.924,12.4,12.4,0,0,1,3.125.795c3.442,1.405,4.869,4.229,3.922,7.818-.909,3.447-3.29,5.672-6.231,7.416a18.4,18.4,0,0,1-3.4,1.525c-.387.134-.494.265-.4.7A4.452,4.452,0,0,1,95.3,220.1a10.985,10.985,0,0,1-4.949,1.214,37.386,37.386,0,0,1-15.424-2.6c-3.186-1.182-6.387-2.321-9.645-3.5",
    transform: "translate(0.001 -183.248)",
    fill: "#ed3a72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3952",
    "data-name": "Path 3952",
    d: "M985.519,552.725a21.58,21.58,0,0,1-17-9.4,1.139,1.139,0,0,1,.015-1.583,9.247,9.247,0,0,0,1.737-3.82c.063-.334.147-.529.595-.431,5.968,1.3,11.654,3.27,16.638,6.929a12.608,12.608,0,0,1,2.841,2.77c1.6,2.223.857,4.363-1.775,5.133a11.862,11.862,0,0,1-3.055.4",
    transform: "translate(-902.834 -501.179)",
    fill: "#ed3a72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3953",
    "data-name": "Path 3953",
    d: "M295.466,552.416a10.741,10.741,0,0,1-3.207-.466c-2.4-.818-3.09-2.792-1.688-4.905a13.682,13.682,0,0,1,4.053-3.747,46.634,46.634,0,0,1,15.469-6.142c.343-.079.494,0,.577.355a11.785,11.785,0,0,0,2.079,4.3.541.541,0,0,1,.012.732,21.5,21.5,0,0,1-17.294,9.877",
    transform: "translate(-270.279 -500.859)",
    fill: "#ed3a72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3954",
    "data-name": "Path 3954",
    d: "M643.323,1.27c.172.637-.168.875-.911,1.06a9.735,9.735,0,0,0-6.132,4.849c-.258.438-.1.623.275.831a8.386,8.386,0,0,1,2.542,2.1,6.581,6.581,0,0,1,1.14,6.478c-.169.519-.328.6-.858.335A17.024,17.024,0,0,0,623,17.061c-.574.305-.57-.046-.684-.377A6.962,6.962,0,0,1,625.228,8.5c1.384-.959,1.39-.963.331-2.354a9.592,9.592,0,0,0-5.85-3.924.485.485,0,0,1-.464-.468c-.273-1.74,0-2,1.655-1.473a12.4,12.4,0,0,1,7.276,6.042A.954.954,0,0,0,629.4,6.9a10.3,10.3,0,0,1,3.958.06c.51.1.716-.051.946-.49a12.1,12.1,0,0,1,7.752-6.28c1.256-.351,1.265-.318,1.267,1.078",
    transform: "translate(-577.346 -0.005)",
    fill: "#ed3a72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3955",
    "data-name": "Path 3955",
    d: "M629.612,651.374a17.6,17.6,0,0,1-10.925-3.952,1.465,1.465,0,0,1-.539-1.856,18.848,18.848,0,0,1,2.168-4.277c.268-.393.451-.4.836-.128a15.2,15.2,0,0,0,18.251-.03c.315-.222.465-.191.661.084a16.087,16.087,0,0,1,2.414,5.065c.126.454-.23.655-.479.885a16.548,16.548,0,0,1-7.421,3.688,20.965,20.965,0,0,1-4.967.523",
    transform: "translate(-576.285 -597.692)",
    fill: "#ed3a72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3956",
    "data-name": "Path 3956",
    d: "M602.478,790.513c1.348.611,2.489,1.23,3.706,1.678a26.978,26.978,0,0,0,21.956-1.245c.233-.113.471-.431.732-.235.231.173.1.517.083.785-.019.414-.046.83-.1,1.24-.473,3.472-1.176,4.486-4.442,5.755-6.869,2.669-13.569,2.388-20.018-1.367a1.919,1.919,0,0,1-.842-.975,16.249,16.249,0,0,1-1.074-5.636",
    transform: "translate(-561.797 -737.136)",
    fill: "#ed3a72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3957",
    "data-name": "Path 3957",
    d: "M649.773,942.277a23.853,23.853,0,0,0,19.952.119c.174.233-.016.353-.091.469a26.463,26.463,0,0,1-9.021,8.644,1.349,1.349,0,0,1-1.566-.029,27.469,27.469,0,0,1-8.668-8.2c-.167-.244-.308-.505-.605-1",
    transform: "translate(-605.898 -878.652)",
    fill: "#ed3a72"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeeStrongActive);
export default __webpack_public_path__ + "static/media/bee-strong-active.0c471cbca0bf9e6bec705702ac9bb88c.svg";
export { ForwardRef as ReactComponent };